import React, { Component } from "react";
import NavBar from "./../Components/navbar";
import Footer from "./../Components/footer";
import settings from "../helpers/Settings";
let { apiToken, user } = settings;

class Login extends Component {
  componentDidMount = () => {
    const { history } = this.props;

    if (apiToken) {
      history.push(`/Sanad/employee`, { name: user });
    }
  };

  render() {
    return (
      <>
        <NavBar />
        <div className="BayanLinks">
          <a href="/Sanad/loginAsEmployee">Login As Employee</a>
        </div>
        <Footer />
      </>
    );
  }
}

export default Login;
